import { DatePicker, Input, message, Modal, Select } from "antd";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { svg } from "../../../../../Assets/svg";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import dayjs from "dayjs";
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from "../../../../../store";
import { GetDepartmentListByProductAPI } from "../../../../Redux/staticData";
import { GetMachineListAPI } from "../../../../Redux/masterData";
import { GetTeamMemberListAPI } from "../../../../Redux/teamMember";
import {
  CapitalizeFirstWord,
  UniqueByIdForDropdown,
  useDebounce,
} from "../../../../../helpers/utils";
import { decryptByText } from "../../../../../helpers/bycrypt";
import { ManufacturingStatus } from "../../orderTypes";
import { BtnLoader } from "../../../../../Components/Components";
import {
  UpdateDataInCalenderAPI,
  GetProductionJobQualityChecklistsAPI,
} from "../../../../Redux/orders";
import { useParams } from "react-router-dom";
import FillQualityChecklistModal from "../../../Manufacturing/Components/FillQualityChecklistModal";
import DescriptionWithShowMore from "../../../../../helpers/DescriptionWithShowMore";

const EditOrderProductionData: React.FC<{
  visible: boolean;
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  isEditData: any;
  setIsEditData: React.Dispatch<React.SetStateAction<any>>;
  setIsMachinConflctData: any;
  setIsMachinConflict: any;
  productionData: any;
  onChecklistRequired?: () => void;
}> = ({
  visible,
  setIsModalVisible,
  isEditData,
  setIsEditData,
  setIsMachinConflctData,
  setIsMachinConflict,
  productionData,
  onChecklistRequired,
}) => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const getDepartmentLoading = useAppSelector(
    (state: RootState) => state.loading.getDepartmentLoading,
  );

  const getMachineLoading = useAppSelector(
    (state: RootState) => state.loading.getMachineLoading,
  );
  const getTeamMemberLoading = useAppSelector(
    (state: RootState) => state.loading.getTeamMemberLoading,
  );
  const updateItemDataCalenderLoading = useAppSelector(
    (state: RootState) => state.loading.updateItemDataCalenderLoading,
  );
  console.log(
    isEditData,
    productionData,
    "isEditDataisEditDataisEditDataisEditData",
  );

  const { productionPlanData, orderDetails } = useAppSelector(
    (state: RootState) => state.orders,
  );

  const onClose = () => {
    setIsModalVisible(false);
    setIsEditData(null);
  };

  const { departmentListByProduct } = useAppSelector(
    (state: RootState) => state.staticData,
  );
  const { machineList } = useAppSelector(
    (state: RootState) => state?.masterData,
  );
  const { teamMemberList } = useAppSelector(
    (state: RootState) => state.teamMember,
  );

  const [editedDepartmentId, setEditedDepartmentId] = useState<any>(
    isEditData?.department_id?._id,
  );

  // Machine pagination state
  const [machinePage, setMachinePage] = useState(1);
  const [hasMoreMachine, setHasMoreMachine] = useState(true);
  const [machineSearch, setMachineSearch] = useState("");
  const debouncedMachineSearch = useDebounce(machineSearch, 300);

  // Employee pagination state
  const [employeePage, setEmployeePage] = useState(1);
  const [hasMoreEmployee, setHasMoreEmployee] = useState(true);
  const [employeeSearch, setEmployeeSearch] = useState("");
  const debouncedEmployeeSearch = useDebounce(employeeSearch, 300);

  // Checklist state variables
  const [showChecklistModal, setShowChecklistModal] = useState(false);
  const [checklistQuestions, setChecklistQuestions] = useState<any[]>([]);
  const [currentChecklistId, setCurrentChecklistId] = useState<string | null>(
    null,
  );
  const [isHalfComplete, setIsHalfComplete] = useState<boolean>(false);
  const [pendingSaveValues, setPendingSaveValues] = useState<any>(null);

  const [isOneClear, setIsOneClear] = useState(false);
  const machinePayload = useMemo(
    () => ({
      page: machinePage,
      limit: 20,
      search: debouncedMachineSearch,
      department: editedDepartmentId,
    }),
    [machinePage, debouncedMachineSearch, editedDepartmentId],
  );

  const employeePayload = useMemo(
    () => ({
      page: employeePage,
      limit: 9,
      search: debouncedEmployeeSearch,
      department: editedDepartmentId,
    }),
    [employeePage, debouncedEmployeeSearch, editedDepartmentId],
  );

  const departmentPayload = { product_id: isEditData?.product?.product_id };

  useEffect(() => {
    if (visible && isEditData?.product?.product_id) {
      dispatch(GetDepartmentListByProductAPI(departmentPayload));
    }
  }, [visible, isEditData?.product_id]);

  useEffect(() => {
    if (visible && editedDepartmentId) {
      if (machinePayload?.page == 1) {
        dispatch({ type: "CLEAR_MACHINE_DATA" });
      }
      dispatch(GetMachineListAPI(machinePayload, setHasMoreMachine));
    }
  }, [dispatch, machinePayload, visible]);

  useEffect(() => {
    if (visible && editedDepartmentId) {
      if (employeePayload?.page == 1) {
        dispatch({ type: "CLEAR_TEAM_MEMBER_ARRAY" });
      }
      dispatch(GetTeamMemberListAPI(employeePayload, setHasMoreEmployee));
    }
  }, [dispatch, employeePayload, visible]);

  // Update editedDepartmentId when isEditData changes or when department is selected
  useEffect(() => {
    if (isEditData?.department_id?._id) {
      setEditedDepartmentId(isEditData?.department_id?._id);
    }
  }, [isEditData]);

  const isDepartmentDisabled = useMemo(() => {
    if (!isEditData || !productionPlanData) return false;

    const isSameProduct = (a: any, b: any) => {
      if (a.item_type !== b.item_type) return false;
      if (["bom_part", "component"].includes(a.item_type)) {
        return a.name === b.name;
      }
      const varA = a.variant_id || a.product?.variants?._id || null;
      const varB = b.variant_id || b.product?.variants?._id || null;
      if (varA || varB) {
        return varA?.toString() === varB?.toString();
      }
      return a.name === b.name;
    };

    const currentDeptId =
      isEditData?.department_id?._id || isEditData?.department_id;
    if (!currentDeptId) return false;

    return (productionPlanData || []).some((item: any) => {
      if (item._id?.toString() === isEditData._id?.toString()) return false;
      if (!isSameProduct(item, isEditData)) return false;
      const itemDeptId = item.department_id?._id || item.department_id;
      return itemDeptId && itemDeptId.toString() === currentDeptId.toString();
    });
  }, [isEditData, productionPlanData]);

  const departmentOptions = useMemo(
    () =>
      UniqueByIdForDropdown([
        ...(isEditData?.department_id && !isOneClear
          ? [isEditData?.department_id]
          : []),
        ...departmentListByProduct,
      ]).map((d: any) => ({ label: d.name, value: d._id })),
    [isEditData?.department_id, departmentListByProduct, isOneClear],
  );

  const machineOptions = useMemo(
    () =>
      UniqueByIdForDropdown([
        ...(isEditData?.machine_id && !isOneClear
          ? [isEditData?.machine_id]
          : []),
        ...machineList,
      ]).map((d: any) => ({ label: d.name, value: d._id })),
    [isEditData?.machine_id, machineList, isOneClear],
  );
  const employeeOptions = useMemo(
    () =>
      UniqueByIdForDropdown([
        ...(isEditData?.employee_ids?.length > 0 && !isOneClear
          ? isEditData?.employee_ids?.map((elem: any) => {
              return {
                ...elem,
                name: `${CapitalizeFirstWord(
                  decryptByText(elem?.first_name),
                )} ${CapitalizeFirstWord(decryptByText(elem?.last_name))}`,
                first_name: CapitalizeFirstWord(
                  decryptByText(elem?.first_name),
                ),
                last_name: CapitalizeFirstWord(decryptByText(elem?.last_name)),
              };
            })
          : []),
        ...teamMemberList,
      ]).map((d: any) => ({ label: d.name, value: d._id })),
    [isEditData?.employee_ids, teamMemberList, isOneClear],
  );

  const handleMachineSearch = useCallback((value: string) => {
    setMachineSearch(value?.trim());
    setMachinePage(1);
    setHasMoreMachine(true);
  }, []);

  const handleEmployeeSearch = useCallback((value: string) => {
    setEmployeeSearch(value?.trim());
    setEmployeePage(1);
    setHasMoreEmployee(true);
  }, []);

  const createScrollHandler = useCallback(
    (
        loading: boolean,
        hasMore: boolean,
        setPage: (fn: (prev: number) => number) => void,
      ) =>
      (event: any) => {
        const target = event.target;
        if (
          !loading &&
          hasMore &&
          Math.abs(
            target.scrollHeight - (target.scrollTop + target.offsetHeight),
          ) < 2
        ) {
          setPage((prev) => prev + 1);
        }
      },
    [],
  );

  const handleMachineScroll = useMemo(
    () =>
      createScrollHandler(getMachineLoading, hasMoreMachine, setMachinePage),
    [createScrollHandler, getMachineLoading, hasMoreMachine],
  );

  const handleEmployeeScroll = useMemo(
    () =>
      createScrollHandler(
        getTeamMemberLoading,
        hasMoreEmployee,
        setEmployeePage,
      ),
    [createScrollHandler, getTeamMemberLoading, hasMoreEmployee],
  );

  const rowSaveSchema = Yup.object().shape({
    qty: Yup.number()
      .required("Qty is required")
      .moreThan(0, "Qty is required")
      .test(
        "qty-vs-manufactured",
        "Qty cannot be less that manufactured qty",
        function (value) {
          const { manufactured } = this.parent;
          return value >= (manufactured || 0);
        },
      ),

    manufactured: Yup.number().test(
      "manufactured-vs-qty",
      "Manufactured qty cannot be greater than qty",
      function (value) {
        const { qty } = this.parent;
        return (value || 0) <= (qty || 0);
      },
    ),

    department_id: Yup.string().required("Department is required"),

    // machine_id: Yup.string().required("Machine is requiredasdasdas"),
    start_date: Yup.date().required("Start Date is required"),

    end_date: Yup.date()
      .required("End Date is required")
      .test(
        "start-before-end",
        "End date cannot be before start date",
        function (value) {
          const { start_date } = this.parent;
          if (!start_date || !value) return true;
          return (
            dayjs(value).isSame(dayjs(start_date), "day") ||
            dayjs(value).isAfter(dayjs(start_date))
          );
        },
      ),

    status: Yup.string()
      .required("Status is required")
      .notOneOf(["init"], "Status is required")
      .test(
        "completed-qty-check",
        "Qty must be equal to manufactured qty before completing",
        function (value) {
          const { qty, manufactured } = this.parent;

          if (value === "completed") {
            return Number(qty || 0) === Number(manufactured || 0);
          }

          return true;
        },
      )
      .test(
        "must-be-completed",
        "Status must be completed when qty equals manufactured qty",
        function (value) {
          const { qty, manufactured } = this.parent;
          if (Number(qty || 0) === Number(manufactured || 0)) {
            return value === "completed";
          }

          return true;
        },
      ),
  });

  const executeActualSave = (values: any, checklistAnswers: any = null) => {
    let quality_checklists: any = undefined;
    if (checklistAnswers) {
      const formattedAnswers = checklistQuestions.map((q: any) => {
        const entry = checklistAnswers[q._id] || {};
        const isQAnswered =
          entry.answer !== null &&
          entry.answer !== undefined &&
          entry.answer !== "";
        return {
          question_id: q._id,
          question_text: q.question_text || "",
          ans_type: q.ans_type || entry.ans_type,
          answer: entry.answer,
          conditional_answer: entry.conditional_answer,
          photo: entry.photo || [],
          photo_required: q.photo_required || false,
          if_yes_action: q.if_yes_action || null,
          if_no_action: q.if_no_action || null,
          is_answered:
            entry.is_answered !== undefined ? entry.is_answered : isQAnswered,
        };
      });

      const selectedUser =
        sessionStorage.getItem("mfg_employee_id") ||
        (values?.employee_ids && values.employee_ids.length > 0
          ? values.employee_ids[0]
          : null);
      const updatedQualityChecklists = isEditData.quality_checklists
        ? [...isEditData.quality_checklists]
        : [];
      const targetGroupIndex = updatedQualityChecklists.findIndex((g: any) =>
        isHalfComplete ? g.half_complete === true : g.full_complete === true,
      );

      if (targetGroupIndex !== -1) {
        updatedQualityChecklists[targetGroupIndex] = {
          ...updatedQualityChecklists[targetGroupIndex],
          questions_data: formattedAnswers,
          is_answered: true,
          submitted_on: new Date().toISOString(),
          selected_user: selectedUser,
        };
      } else {
        updatedQualityChecklists.push({
          checklist_id: currentChecklistId,
          half_complete: isHalfComplete,
          full_complete: !isHalfComplete,
          department_id: values.department_id,
          questions_data: formattedAnswers,
          is_answered: true,
          submitted_on: new Date().toISOString(),
          selected_user: selectedUser,
        });
      }
      quality_checklists = updatedQualityChecklists;
    }

    const payload = [
      {
        items_id: isEditData?.item_id,
        splits: [
          {
            _id: isEditData?._id,
            qty: values?.qty,
            manufactured_qty: values?.manufactured,
            employee_ids: values?.employee_ids,
            pending_qty: values?.qty - values?.manufactured,
            status: values?.status,
            start_at: values?.start_date,
            end_at: values?.end_date,
            machine_id: values?.machine_id ? values?.machine_id : null,
            department_id: values?.department_id,
            variant_id: isEditData?.variant_id,
            ...(quality_checklists ? { quality_checklists } : {}),
          },
        ],
      },
    ];

    const handleConflict = (conData: any) => {
      const conPayload = {
        product_name: conData?.item?.name,
        start_date: conData?.item?.splits?.start_at,
        end_date: conData?.item?.splits?.end_at,
        order_number: conData?.order?.order_id,
      };
      setIsMachinConflctData(conPayload);
      setIsMachinConflict(true);
    };

    const handleSuccess = (successData: any) => {
      const customizedList = Array.isArray(successData)
        ? successData
        : successData?.customized_data || [];

      let findData = customizedList?.find(
        (item: any) => item?._id == isEditData?._id,
      );

      if (!findData && successData?.planning?.items) {
        for (const item of successData.planning.items) {
          const matchingSplit = (item.splits || []).find(
            (s: any) => s._id?.toString() === isEditData?._id?.toString(),
          );
          if (matchingSplit) {
            findData = {
              ...isEditData,
              ...matchingSplit,
              department_id:
                matchingSplit?.department_id || isEditData?.department_id,
              machine_id: matchingSplit?.machine_id || isEditData?.machine_id,
              employee_ids:
                matchingSplit?.employee_ids || isEditData?.employee_ids,
              start_at: matchingSplit?.start_at,
              end_at: matchingSplit?.end_at,
              status: matchingSplit?.status,
              qty: matchingSplit?.qty,
              pending_qty: matchingSplit?.pending_qty,
              manufactured_qty: matchingSplit?.manufactured_qty,
            };
            break;
          }
        }
      }

      setShowChecklistModal(false);
      if (findData) {
        dispatch({
          type: "UPDATE_PRODUCTION_PLAN_PRODUCT",
          payload: findData,
        });
      }
      message.success("Production plan updated successfully!");
      onClose();
    };

    dispatch(
      UpdateDataInCalenderAPI(id, payload, handleSuccess, handleConflict),
    );
  };

  const isChecklistRequired = Boolean(
    orderDetails?.installation_mark_up_required,
  );
  const isChecklistFilled =
    !isChecklistRequired ||
    Boolean(orderDetails?.is_installation_checklist_filled);

  const handleSave = (values: any) => {
    if (!isChecklistFilled) {
      if (onChecklistRequired) {
        onChecklistRequired();
      }
      return;
    }
    const replaceOwnProperty: any = productionPlanData?.map((item: any) => {
      return isEditData?._id == item?._id ? { ...item, ...values } : item;
    });
    const findedData = replaceOwnProperty?.filter((item: any) => {
      return (
        item?.item_id == values?.item_id &&
        item?.categories_snapshot?._id == values?.category_snap_id &&
        (item?.department_id?._id == values?.department_id ||
          item?.department_id == values?.department_id)
      );
    });
    const findedQty = (findedData || [])?.reduce((acc: any, item: any) => {
      return acc + item?.qty;
    }, 0);
    const FinalQty = isEditData?.product?.variant_qty;
    if (FinalQty < findedQty) {
      message.error("Entered quantity exceeds the master quantity.");
      return;
    }

    const totalQty = Number(
      isEditData?.item_quantity || isEditData?.product?.variant_qty || 0,
    );
    const halfQty = totalQty / 2;

    const otherSplits = (productionPlanData || []).filter((item: any) => {
      if (item._id?.toString() === isEditData?._id?.toString()) return false;
      if (item.item_id?.toString() !== isEditData?.item_id?.toString())
        return false;
      const itemDeptId = item.department_id?._id || item.department_id;
      const currentDeptId = values.department_id;
      return (
        itemDeptId &&
        currentDeptId &&
        itemDeptId.toString() === currentDeptId.toString()
      );
    });

    const otherSplitsTotal = otherSplits.reduce(
      (sum: number, item: any) => sum + Number(item.manufactured_qty || 0),
      0,
    );
    const newTotal = otherSplitsTotal + Number(values.manufactured);

    const departmentId = values.department_id;

    const allSplitsForThisDept = (productionPlanData || []).filter(
      (item: any) => {
        if (item.item_id?.toString() !== isEditData?.item_id?.toString())
          return false;
        const itemDeptId = item.department_id?._id || item.department_id;
        const currentDeptId = values.department_id;
        return (
          itemDeptId &&
          currentDeptId &&
          itemDeptId.toString() === currentDeptId.toString()
        );
      },
    );

    let hasHalfComplete = false;
    let hasFullComplete = false;
    allSplitsForThisDept.forEach((split: any) => {
      const checklists = split.quality_checklists || [];
      checklists.forEach((qc: any) => {
        if (qc.half_complete === true && qc.is_answered === true) {
          hasHalfComplete = true;
        }
        if (qc.full_complete === true && qc.is_answered === true) {
          hasFullComplete = true;
        }
      });
    });

    let isCrossingHalf =
      totalQty > 0 && newTotal >= halfQty && newTotal != totalQty;
    let isCrossingFull = totalQty > 0 && newTotal >= totalQty;

    if (hasHalfComplete) isCrossingHalf = false;
    if (hasFullComplete) isCrossingFull = false;

    const shouldPromptChecklist =
      (isCrossingHalf || isCrossingFull) && departmentId;
    const currentHalfComplete = isCrossingFull ? false : true;

    if (shouldPromptChecklist) {
      dispatch(
        GetProductionJobQualityChecklistsAPI(
          { job_id: isEditData._id },
          (data: any) => {
            const targetQc = data?.quality_checklists?.find((q: any) =>
              currentHalfComplete
                ? q.half_complete === true
                : q.full_complete === true,
            );
            if (targetQc && targetQc.checklist_id?.questions?.length > 0) {
              setIsHalfComplete(currentHalfComplete);
              setChecklistQuestions(targetQc.checklist_id.questions);
              setCurrentChecklistId(targetQc.checklist_id._id);
              setPendingSaveValues(values);
              setShowChecklistModal(true);
            } else {
              executeActualSave(values, null);
            }
          },
        ),
      );
    } else {
      executeActualSave(values, null);
    }
  };
  return (
    <>
      <Modal
        title={
          <div className="text-center fs-4 fs-4-mobile fw-bolder lh-m d-flex flex-column">
            {["bom_part", "component"]?.includes(isEditData?.item_type)
              ? isEditData?.name
              : `${isEditData?.product?.variants?.variant_name}`}
            <span className="fs-6 fs-6-mob text-949494 fw-normal lh-m text-dark">
              {["bom_part", "component"]?.includes(isEditData?.item_type) ? (
                ""
              ) : (
                <DescriptionWithShowMore
                  description={isEditData?.product?.description}
                />
              )}
              {isEditData?.product?.variants?.max_load_per_bay && (
                <div className="lh-tight">
                  Max Load per Bay:{" "}
                  {isEditData?.product?.variants.max_load_per_bay}
                </div>
              )}
              {isEditData?.product?.variants?.max_load_per_pair && (
                <div className="lh-tight">
                  Max Load per Pair:{" "}
                  {isEditData?.product?.variants.max_load_per_pair}
                </div>
              )}
              {isEditData?.product?.variants?.max_load_per_shelf && (
                <div className="lh-tight">
                  Max Load per Shelf:{" "}
                  {isEditData?.product?.variants.max_load_per_shelf}
                </div>
              )}
            </span>
          </div>
        }
        visible={visible}
        onCancel={onClose}
        width={"50rem"}
        closeIcon={svg?.closeIcon}
        centered
        footer={null}
        className="commonModalClass"
      >
        <Formik
          initialValues={{
            start_date: isEditData?.start_at ? isEditData?.start_at : null,
            end_date: isEditData?.end_at ? isEditData?.end_at : null,
            qty: isEditData?.qty || "",
            manufactured: isEditData?.manufactured_qty || 0,
            pending_qty: isEditData?.pending_qty || 0,
            status:
              isEditData?.status === "init" || !isEditData?.status
                ? "scheduled"
                : isEditData?.status,
            specifications: isEditData?.specifications || "",
            department_id: isEditData?.department_id?._id || null,
            machine_id: isEditData?.machine_id?._id || null,
            employee_ids:
              isEditData?.employee_ids?.map((item: any) => item?._id) || [],
            variant_id: isEditData?.variant_id,
            category_snap_id: isEditData?.categories_snapshot?._id,
            item_id: isEditData?.item_id,
          }}
          validationSchema={rowSaveSchema}
          onSubmit={handleSave}
          enableReinitialize
        >
          {({
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            errors,
            touched,
            setFieldValue,
          }: any) => {
            return (
              <Form
                id="submitEditProduct"
                onSubmit={handleSubmit}
                className="page-form"
              >
                <div className="row gy-3">
                  <div className="col-md-6">
                    <div className="form-item">
                      <label className="custom-label mb-1 ff d-flex align-items-center justify-content-between">
                        Quantity{" "}
                        <span className="text-949494">
                          (Product Qty:{isEditData?.product?.variant_qty})
                        </span>
                      </label>
                      <Field
                        name="qty"
                        type="number"
                        min={1}
                        className="form-control form-control-lg"
                        placeholder={"Enter Quantity"}
                        onWheel={(e: any) => e.currentTarget.blur()}
                        as={Input}
                        onKeyDown={(e: any) => {
                          const allowedKeys = [
                            "Backspace",
                            "Delete",
                            "ArrowLeft",
                            "ArrowRight",
                            "Tab",
                          ];

                          if (
                            allowedKeys.includes(e.key) ||
                            (e.key >= "0" && e.key <= "9")
                          ) {
                            return;
                          }

                          e.preventDefault();
                        }}
                      />
                      {errors?.qty && (
                        <div className="text-danger fs-8">{errors?.qty}</div>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-item">
                      <label className="custom-label mb-1 ff">Department</label>
                      <Select
                        placeholder="Select Department"
                        showSearch={false}
                        filterOption={false}
                        value={values?.department_id}
                        onChange={(val) => {
                          setFieldValue("department_id", val);
                          setEditedDepartmentId(val);
                          setIsOneClear(true);
                          setFieldValue("machine_id", null); // Reset machine when dept changes
                          setFieldValue("employee_ids", []); // Reset employees when dept changes
                        }}
                        options={departmentOptions}
                        suffixIcon={svg?.selectDownArrow}
                        className="w-100"
                        allowClear
                        loading={getDepartmentLoading}
                        disabled={isDepartmentDisabled}
                      />
                      {errors?.department_id && (
                        <div className="text-danger fs-8">
                          {errors?.department_id}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-item">
                      <label className="custom-label mb-1 ff">Machine</label>
                      <Select
                        placeholder="Select Machine"
                        showSearch
                        filterOption={false}
                        onSearch={handleMachineSearch}
                        onPopupScroll={handleMachineScroll}
                        value={values?.machine_id}
                        onChange={(val) =>
                          setFieldValue("machine_id", val || null)
                        }
                        options={machineOptions}
                        suffixIcon={svg?.selectDownArrow}
                        className="w-100"
                        allowClear
                        disabled={!values.department_id}
                        loading={getMachineLoading}
                      />
                      {errors?.machine_id && (
                        <div className="text-danger fs-8">
                          {errors?.machine_id}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-item">
                      <label className="custom-label mb-1 ff">Employees</label>
                      <Select
                        placeholder="Select Employees"
                        mode="multiple"
                        className="w-100 custom-select-edit"
                        showSearch
                        filterOption={false}
                        onSearch={handleEmployeeSearch}
                        onPopupScroll={handleEmployeeScroll}
                        value={values?.employee_ids}
                        onChange={(val: any) => {
                          setFieldValue("employee_ids", val);
                        }}
                        options={employeeOptions}
                        suffixIcon={svg?.selectDownArrow}
                        allowClear
                        disabled={!values.department_id}
                        loading={getTeamMemberLoading}
                      />
                      {errors?.employee_ids && (
                        <div className="text-danger fs-8">
                          {errors?.employee_ids}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-item">
                      <label className="custom-label mb-1 ff">Start Date</label>
                      <DatePicker
                        format={"DD-MM-YYYY"}
                        popupClassName="customDatepickerDropdown"
                        value={
                          values.start_date ? dayjs(values.start_date) : null
                        }
                        onChange={(val) => {
                          setFieldValue(
                            "start_date",
                            val ? val.startOf("day").toISOString() : null,
                          );
                          if (
                            values?.end_date &&
                            val &&
                            dayjs(val).isAfter(dayjs(values?.end_date), "day")
                          ) {
                            setFieldValue("end_date", null);
                          }
                        }}
                        disabledDate={(current) => {
                          if (!current) return false;
                          const start = productionData?.production_start_date
                            ? dayjs(
                                productionData?.production_start_date,
                              ).startOf("day")
                            : dayjs(new Date())?.startOf("day");
                          const end = productionData?.production_completion_date
                            ? dayjs(
                                productionData?.production_completion_date,
                              ).endOf("day")
                            : null;
                          if (start && current.isBefore(start)) return true;
                          if (end && current.isAfter(end)) return true;

                          return false;
                        }}
                        className="w-100 form-control-lg"
                      />
                      {errors.start_date && (
                        <div className="text-danger fs-8">
                          {errors.start_date as string}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-item">
                      <label className="custom-label mb-1 ff">End Date</label>
                      <DatePicker
                        format={"DD-MM-YYYY"}
                        popupClassName="customDatepickerDropdown"
                        value={
                          values?.end_date && dayjs(values?.end_date).isValid()
                            ? dayjs(values?.end_date)
                            : null
                        }
                        onChange={(val) =>
                          setFieldValue(
                            "end_date",
                            val ? val.endOf("day").toISOString() : null,
                          )
                        }
                        defaultPickerValue={
                          values?.end_date && dayjs(values?.end_date).isValid()
                            ? dayjs(values?.end_date)
                            : values?.start_date &&
                              dayjs(values?.start_date).isValid()
                            ? dayjs(values?.start_date)
                            : undefined
                        }
                        disabledDate={(current) => {
                          if (!current) return false;

                          const start = values?.start_date
                            ? dayjs(values?.start_date).startOf("day")
                            : productionData?.production_start_date
                            ? dayjs(
                                productionData?.production_start_date,
                              ).startOf("day")
                            : dayjs(new Date())?.startOf("day");
                          const end = productionData?.production_completion_date
                            ? dayjs(
                                productionData?.production_completion_date,
                              ).endOf("day")
                            : null;

                          if (start && current.isBefore(start)) return true;
                          if (end && current.isAfter(end)) return true;

                          return false;
                        }}
                        className="w-100 form-control-lg"
                      />
                      {errors.end_date && (
                        <div className="text-danger fs-8">
                          {errors.end_date as string}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-item">
                      <label className="custom-label mb-1 ff">
                        Manufactured Quantity
                      </label>
                      <Field
                        name="manufactured"
                        as={Input}
                        // disabled
                        type="number"
                        className="form-control form-control-lg"
                        placeholder="Manufactured Qty"
                        onWheel={(e: any) => e.target.blur()}
                        onKeyDown={(e: any) => {
                          const allowedKeys = [
                            "Backspace",
                            "Delete",
                            "ArrowLeft",
                            "ArrowRight",
                            "Tab",
                          ];

                          if (
                            allowedKeys.includes(e.key) ||
                            (e.key >= "0" && e.key <= "9")
                          ) {
                            return;
                          }

                          e.preventDefault();
                        }}
                      />
                      {errors.manufactured && (
                        <div className="text-danger fs-8">
                          {errors.manufactured}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-item">
                      <label className="custom-label mb-1 ff">
                        Pending Quantity
                      </label>
                      <Field
                        name="pending_qty"
                        as={Input}
                        type="number"
                        value={Number(values.qty) - Number(values.manufactured)}
                        className="form-control form-control-lg"
                        placeholder="Pending Qty"
                        disabled
                      />
                      {errors.pending_qty && (
                        <div className="text-danger fs-8">
                          {errors.pending_qty}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-item">
                      <label className="custom-label mb-1 ff">Status</label>
                      <Select
                        value={values.status === "init" ? null : values?.status}
                        onChange={(val) => {
                          if (
                            val === "completed" &&
                            Number(values.qty) != Number(values.manufactured)
                          ) {
                            message.error(
                              "Pending quantity found. Please complete the manufacturing process.",
                            );
                          } else {
                            setFieldValue("status", val);
                          }
                        }}
                        className="w-100"
                      >
                        {ManufacturingStatus.map((statusOption: any) => (
                          <Select.Option
                            key={statusOption.value}
                            value={statusOption.value}
                          >
                            <span style={{ color: statusOption?.color }}>
                              {statusOption.label}
                            </span>
                          </Select.Option>
                        ))}
                      </Select>
                      {errors.status && (
                        <div className="text-danger fs-8">{errors.status}</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-center gap-4 mt-4">
                  <button
                    type="button"
                    className="btn btn-lg btn-outline-secondary min-w-130"
                    onClick={onClose}
                    disabled={updateItemDataCalenderLoading}
                  >
                    CLOSE
                  </button>
                  <button
                    type="submit"
                    className="btn btn-lg btn-primary min-w-130"
                    disabled={updateItemDataCalenderLoading}
                  >
                    {updateItemDataCalenderLoading ? <BtnLoader /> : "SAVE"}
                  </button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </Modal>
      {showChecklistModal && (
        <FillQualityChecklistModal
          visible={showChecklistModal}
          checklistQuestions={checklistQuestions}
          setIsModalVisible={setShowChecklistModal}
          isHalfComplete={isHalfComplete}
          onOk={(answers: any) => {
            if (pendingSaveValues) {
              executeActualSave(pendingSaveValues, answers);
              setPendingSaveValues(null);
            }
          }}
          loading={updateItemDataCalenderLoading}
        />
      )}
    </>
  );
};

export default EditOrderProductionData;
